import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { VaultFile, VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";

export enum SortType {
  LAST_USE_TIME_DESC = "LAST_USE_TIME,DESC",
  LAST_USE_TIME = "LAST_USE_TIME",
}

export type UsedFilesMap = Record<VaultFile["uuid"], boolean>;

export type ThreadSubject = Subject<VaultFileUsageSubjectTypeEnum.MESSAGE_THREAD>;
